import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';
import Cookies from 'js-cookie';

export default class MailchimpFormModal {

	constructor(element) {
		this.handleCloseClick = this.handleCloseClick.bind(this);
		this.handleTriggerClick = this.handleTriggerClick.bind(this);
		this.element = element;
		this.openClass = 'gigs-mailchimp-form-modal--open';
		this.successClass = 'gigs-mailchimp-form-modal--success';
		this.closeButton = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-mailchimp-form-modal__close') : undefined;
		this.overlay = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-mailchimp-form-modal__overlay') : undefined;
		this.form = (this.element instanceof HTMLElement) ? this.element.querySelector('#mc-embedded-subscribe-form') : undefined;
		this.autoshow = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-autoshow') === 'true' : false;
		this.openTimeout = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-autoshow-timeout') : undefined;
		this.openTimer = undefined;
		this.seenCookie = 'gigs_mailchimp_form_seen';
		this.successParam = 'mailchimp-success';
		this.triggerQuery = (this.element instanceof HTMLElement) ? `a[href="#${this.element.id}"]` : '';
		this.seenCookieOptions = {
			expires: 365, // days
		};
		this.focusTrap = null;
		this.wpAdminBar = document.getElementById('wpadminbar');
		this.focusableElements = [this.element];
		if (this.wpAdminBar) this.focusableElements.push(this.wpAdminBar);
	}

	init() {
		if (this.closeButton instanceof HTMLElement) {
			this.closeButton.addEventListener('click', this.handleCloseClick);
		}
		if (this.overlay instanceof HTMLElement) {
			this.overlay.addEventListener('click', this.handleCloseClick);
		}
		this.initTriggers();
		this.initFocusTrap();
		this.checkURL();
		if (! this.hasSeenCookie()) {
			this.setTimeout();
		}
	}

	destroy() {
		if (this.closeButton instanceof HTMLElement) {
			this.closeButton.removeEventListener('click', this.handleCloseClick);
		}
		if (this.overlay instanceof HTMLElement) {
			this.overlay.removeEventListener('click', this.handleCloseClick);
		}
		this.clearTimeout();
		this.destroyTriggers();
		this.destroyFocusTrap();
	}

	initFocusTrap() {
		this.focusTrap = createFocusTrap(this.focusableElements, {
			onDeactivate: () => this.close(),
		});
	}

	destroyFocusTrap() {
		if (this.focusTrap) {
			this.focusTrap.deactivate();
			this.focusTrap = null;
		}
	}

	initTriggers(container) {
		container = (container instanceof HTMLElement) ? container : document;
		if (this.triggerQuery) {
			const triggers = container.querySelectorAll(this.triggerQuery);
			triggers.forEach(trigger => {
				trigger.addEventListener('click', this.handleTriggerClick);
			});
		}
	}

	destroyTriggers(container) {
		container = (container instanceof HTMLElement) ? container : document;
		if (this.triggerQuery) {
			const triggers = container.querySelectorAll(this.triggerQuery);
			triggers.forEach(trigger => {
				trigger.removeEventListener('click', this.handleTriggerClick);
			});
		}
	}

	handleTriggerClick(e) {
		e.preventDefault();
		this.open();
	}

	checkURL() {
		const { search } = window.location;
		const params = new URLSearchParams(search);
		if (params.has(this.successParam)) {
			if (this.element instanceof HTMLElement) {
				this.element.classList.add(this.successClass);
				this.open();
			}
			this.setSeenCookie();
		}
	}

	open() {
		if (this.element instanceof HTMLElement) {
			this.element.classList.add(this.openClass);
			this.focusTrap.activate();
			disableBodyScroll(this.element);
		}
	}

	close() {
		this.setSeenCookie();
		this.removeSuccessParam();
		if (this.element instanceof HTMLElement) {
			this.focusTrap.deactivate();
			this.element.classList.remove(this.openClass);
			enableBodyScroll(this.element);
		}
	}

	setTimeout() {
		this.clearTimeout();
		if (this.autoshow) {
			this.openTimer = window.setTimeout(() => this.open(), Number(this.openTimeout || 0));
		}
	}

	clearTimeout() {
		if (this.openTimer) window.clearTimeout(this.openTimer);
	}

	hasSeenCookie() {
		return Boolean(Cookies.get(this.seenCookie));
	}

	setSeenCookie() {
		Cookies.set(this.seenCookie, '1', this.seenCookieOptions);
	}

	removeSuccessParam() {
		const { search, origin, pathname } = window.location;
		const params = new URLSearchParams(search);
		if (params.has(this.successParam)) {
			params.delete(this.successParam);
			window.history.replaceState({}, '', `${origin}${pathname}${params.toString() ? '?' + params.toString : ''}`);
		}
	}

	handleCloseClick(e) {
		e.preventDefault();
		this.close();
	}
}
